import * as React from 'react';
import { connect } from 'react-redux';
import DataTable from '../DataTable/presentation/DataTable';
import { IRedactedField } from './common/defaults';
import { Button, Form } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import { getRedactedFields, saveRedactedField } from './redux-objects/actions';
import { toast } from 'react-toastify';
import { addAdminLog } from '../AuditLogs/adminLog';
import { UserInfo } from '../Login/common/defaults';
import * as documentDownloadService from '../../../src/services/documentDownloadService';

enum ServiceEndPoints {
  CrashProps = 'CrashProps',
  SaveRedaction = 'SaveRedaction',
  Sample = 'MakeSampleRedactedPublicForm40',
}

interface IRedactedFieldsActionProps {
  getRedactedFields?: (url: string) => void;
  saveRedactedField?: (url: string, fieldname: string) => void;
}
interface IRedactedFieldsStateProps {
  redactedFields: IRedactedField[];
  webServiceURL: string;
  elasticSearchURL: string;
  currentUser: UserInfo;
}
interface IRedactedFieldsProps
  extends IRedactedFieldsActionProps,
    IRedactedFieldsStateProps {}

const initialState = { redactedOnly: false, isGenerating: false };
type IRedactedFieldsState = Readonly<typeof initialState>;

class RedactedFields extends React.Component<
  IRedactedFieldsProps,
  IRedactedFieldsState
> {
  private adminController: string = 'Admin';
  private crashController: string = 'Crash';

  public constructor(props: IRedactedFieldsProps) {
    super(props);
    this.state = initialState;
  }
  componentDidMount() {
    if (!this.props.redactedFields || this.props.redactedFields.length == 0)
      this.populateTable();
  }
  populateTable() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.adminController,
      ServiceEndPoints.CrashProps
    );
    if (this.state.redactedOnly) {
      uri = uri + '?redactedOnly=true';
    }
    this.props.getRedactedFields(uri);
  }

  onSampleRedacted(e) {
    this.setState({ ...this.state, isGenerating: true }, () => {
      const uri = GetURIByParts(
        this.props.webServiceURL,
        this.crashController,
        ServiceEndPoints.Sample
      );
      console.log(e);
      documentDownloadService
        .sampleRedactedPdf(uri)
        .then(() => this.setState({ ...this.state, isGenerating: false }));
    });
  }

  toggleRedactedOnly() {
    this.setState(
      { ...this.state, redactedOnly: !this.state.redactedOnly },
      () => {
        this.populateTable();
      }
    );
  }

  toggleRedaction(event: React.MouseEvent<HTMLElement>, fullData: any): void {
    this.props.saveRedactedField(
      GetURIByParts(
        this.props.webServiceURL,
        this.adminController,
        ServiceEndPoints.SaveRedaction
      ),
      fullData
    );

    const desc = fullData.isRedacted
      ? `Field ${fullData.fieldName} Redacted`
      : `Field ${fullData.fieldName} Un-Redacted`;
    addAdminLog(
      this.props.elasticSearchURL,
      'Redacted Field update',
      desc,
      {},
      this.props.currentUser.username
    );

    if (fullData.isRedacted) {
      toast.error('Removed Redaction');
    } else {
      toast.success('Set Redaction');
    }
  }
  public render() {
    const options = {
      dom: 'Bfrtip',
    };
    const columns = [
      {
        title: 'Redacted',
        data: 'isRedacted',
      },
      {
        title: 'Field',
        data: 'fieldName',
      },
    ];

    const columnDefs = [
      {
        targets: 0,
        width: '160px',
        orderable: false,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Form.Group controlId={'chkRedact' + rowData.id}>
                <Form.Check
                  type='checkbox'
                  label={rowData.isRedacted ? 'Redacted' : ''}
                  checked={rowData.isRedacted}
                  onChange={(e) => this.toggleRedaction(cellData, rowData)}
                />
              </Form.Group>
            </div>,
            td
          ),
      },
    ];

    return (
      <div>
        <Form.Group controlId='chkRedactedOnly'>
          <Form.Check
            type='checkbox'
            label='Show only Redacted'
            checked={this.state.redactedOnly}
            onChange={(e) => this.toggleRedactedOnly()}
          />
        </Form.Group>
        <DataTable
          id='tblRedactedFields'
          data={this.props.redactedFields}
          columns={columns}
          columnDefs={columnDefs}
          actionsColumn='first'
          order={[[1, 'asc']]}
          select={false}
          {...options}
        />
        <br />
        <br />
        <br />
        <hr />
        <Button
          disabled={this.state.isGenerating}
          onClick={(e) => this.onSampleRedacted(e.target)}
        >
          {this.state.isGenerating && (
            <div>
              Generating Sample{'   '}
              <img
                src={require('../../../src/assets/SmartAdmin/img/loading.gif')}
              />
            </div>
          )}
          {!this.state.isGenerating && <div>Sample</div>}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    redactedFields: state.RedactedFields.redactedFields,
    webServiceURL: state.Application.backendURL,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
  };
};

const mapDispatchToProps = {
  getRedactedFields,
  saveRedactedField,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedactedFields);
